<template>
    <div >
        <f-title
            v-if   = "showTitle"
            class  = "mt-2"
            :title = "$t('contract.terms')"
        />

        <v-row class="no-frame">
            <f-read-only-field
                v-if   = "unitMode"
                class  = "w-100 ro-gap"
                :label    = "$t('contract.mnt.contracttype')"
                :value = "contract.contracttype ? contract.contracttype.name : ''"
                color  = "pt-0-5 pl-1 ro-background"
            />
            <f-enum-select
                v-if      = "!unitMode"
                v-model   = "contract.contracttype"
                :label    = "$t('contract.mnt.contracttype')"
                :readonly = "readonly"
                module    = "msd"
                type      = "contractMntTypes"
                :rules    =" [ selectRequired]"
            />
        </v-row>

        <v-row class="no-frame" v-if="unitMode">
            <v-col class="no-frame pr-2">
                <f-read-only-field
                    v-if   = "unitMode && readonly"
                    class  = "w-100 ro-gap"
                    :label    = "$t('contract.mnt.costsPerYear')"
                    :value = "moneyAsString(contract.unit.costs)"
                    color  = "pt-0-5 pl-1 ro-background"
                />

                <f-currency-field
                    v-if      = "!readonly"
                    class     = "money"
                    :label    = "$t('contract.mnt.costsPerYear')"
                    :readonly = "readonly"
                    v-model   = "contract.unit.costs"
                />
            </v-col>
            <v-col class="no-frame pl-2">
                <f-read-only-field
                    v-if           = "unitMode && readonly"
                    class          = "w-100 ro-gap"
                    :label         = "$t('contract.mnt.countPerYear')"
                    :value         = "contract.unit.count"
                    color          = "pt-0-5 pl-1 ro-background"
                />

                <v-text-field
                    v-if           = "!readonly"
                    type           = "number"
                    :label         = "$t('contract.mnt.countPerYear')"
                    v-model        = "contract.unit.count"
                    :readonly      = "readonly"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                />
            </v-col>
        </v-row>

        <v-row class="no-frame">
            <v-col class="no-frame">
                <span class="primary--text">Inclusive:</span>
            </v-col>
        </v-row>

        <v-row class="no-frame" :class="readonly || unitMode ? 'ro-background' : ''">
            <v-col class="no-frame pr-2">
                <v-checkbox
                    v-model   = "contract.rentIncluded"
                    :label    = "$t('contract.mnt.rentIncluded')"
                    :readonly = "readonly || unitMode"
                    class     = "mt-0 pt-0"
                    :ripple   = "false"
                    hide-details
                />
                <v-checkbox
                    v-model   = "contract.standByIncluded"
                    :label    = "$t('contract.mnt.standByIncluded')"
                    :readonly = "readonly || unitMode"
                    class     = "mt-0 pt-0"
                    :ripple   = "false"
                    hide-details
                />
                <v-checkbox
                    v-model   = "contract.teleserviceIncluded"
                    :label    = "$t('contract.mnt.teleserviceIncluded')"
                    :readonly = "readonly || unitMode"
                    :ripple   = "false"
                    class     = "mt-0 pa-0"
                    hide-details
                />
                <v-checkbox
                    v-model   = "contract.inspectionIncluded"
                    :label    = "$t('contract.mnt.inspectionIncluded')"
                    :readonly = "readonly || unitMode"
                    :ripple   = "false"
                    class     = "mt-0 pa-0"
                    hide-details
                />
                <v-checkbox
                    v-model   = "contract.phoneIncluded"
                    :label    = "$t('contract.mnt.phoneIncluded')"
                    :readonly = "readonly || unitMode"
                    class     = "mt-0 pt-0"
                    :ripple   = "false"
                    hide-details
                />
                <v-checkbox
                    v-model   = "contract.guardIncluded"
                    :label    = "$t('contract.mnt.guardIncluded')"
                    :readonly = "readonly || unitMode"
                    class     = "mt-0 pt-0"
                    :ripple   = "false"
                    hide-details
                />
                <v-checkbox
                    v-model   = "contract.smokeextractionIncluded"
                    :label    = "$t('contract.mnt.smokeextractionIncluded')"
                    :readonly = "readonly || unitMode"
                    :ripple   = "false"
                    class     = "mt-0 pa-0"
                    hide-details
                />
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <div
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-checkbox
                                v-model   = "contract.inspectioAddOnIncluded"
                                :label    = "$t('contract.mnt.inspectioAddOnIncluded')"
                                :ripple   = "false"
                                :readonly = "readonly || unitMode"
                                class     = "mt-0 pa-0"
                                hide-details
                            />
                        </div>
                    </template>
                    <span>{{ $t('contract.mnt.inspectioAddOnIncludedTooltip') }}</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row class="no-frame" :class="readonly || unitMode ? 'ro-background' : ''">
            <v-col class="col-6 no-frame pr-2 v-flex">
                <v-checkbox
                    v-model   = "contract.incidentsIncluded"
                    :label    = "$t('contract.mnt.incidentIncluded')"
                    :readonly = "readonly || unitMode"
                    :ripple   = "false"
                    class     = "mt-0 pa-0"
                    :hide-details = "true"
                />
            </v-col>
            <v-col class="col-6 no-frame pl-2 pr-2 v-flex">
                <div v-if="contract.incidentsIncluded" class="primary--text pl-1">bis</div>
                <f-currency-field
                    v-if      = "contract.incidentsIncluded"
                    class     = "money"
                    :readonly = "readonly || unitMode"
                    v-model   = "contract.maxIncidentCosts"
                    style     = "padding-top: 0; margin-top: -3px;"
                    :hide-details = "true"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import FCurrencyField from "@/modules/core/components/utils/FCurrencyField";
import FEnumSelect from "@/modules/core/components/utils/FEnumSelect";
import FTitle from "@/modules/core/components/utils/FTitle";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField.vue";
import Core from "@/modules/core/service/Core";
export default {
    name: "CContractMntTerms",
    components: {
        FReadOnlyField,
        FTitle,
        FEnumSelect,
        FCurrencyField
    },

    props: {
        contract: {
            required : true,
            type     : Object,
            default  : function () {
                return {
                    incidentsIncluded: null,
                    maxIncidentCosts: null
                }
            }
        },

        showTitle: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        unitMode: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        readonly: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        }
    },

    methods: {
        selectRequired (value) {
            if (value && value.id === 0) {
                return true;
            }

            if (!value || !value.id) {
                return this.$t("common.required");
            }

            return true;
        },

        moneyAsString (value) {
            return Core.format.money(value);
        }
    }
}
</script>

<style scoped>

</style>